// extracted by mini-css-extract-plugin
module.exports = {"root":"Footer_root__atgai","inner":"Footer_inner__3Lvz3"};